





























































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import { MasterModule } from '@/app/store/modules/master'
import { MasterCarStateDataModule } from '@/app/store/modules/masterCar'

@Component({
  name: 'FilterChart',
  components: {
    'date-picker': DatePicker,
  },
})
export default class extends Vue {
  @Prop({}) private isDisabled: boolean | undefined
  @Prop({}) private funcFilter: any | undefined
  @Prop({}) private funcClearFilter: any | undefined
  @Prop({}) private hasFilter: boolean | undefined
  @Prop({}) private onClearFilter: boolean | undefined

  @Watch('onClearFilter')
  public changeHasFilter(value: boolean, oldValue: boolean) {
    this.city = ''
    this.cityId = ''
    this.dealerName = ''
    this.dealerNameId = ''
    this.dealerBranch = ''
    this.dealerBranchId = ''
    this.category = ''
    this.categoryId = ''
    this.filterDate = []
  }

  // enable button filter
  public get enableButtonFilter() {
    if (
      (this.city.length === 0 &&
        this.dealerNameOptions.length === 0 &&
        this.dealerBranchOptions.length === 0 &&
        this.category.length === 0 &&
        this.filterDate.length === 0) ||
      this.filterDate === []
    ) {
      return true
    } else {
      return false
    }
  }

  // FIlter By City
  public city: string = ''
  public cityId: string = ''
  public byCitizen(text) {
    const find = this.cityOptions.find((e) => e.name === text)
    const index = this.cityOptions.indexOf(find)
    if (text.length >= 3 && index === -1) {
      MasterModule.paginationParam.search = text
      MasterModule.getCity()
    }
    if (this.cityOptions.length > 0) {
      this.cityId = this.cityOptions.find((e) => e.name === text).id
    }
  }
  public cityOptions: any = []
  public get cityCode() {
    this.cityOptions = MasterModule.MasterData.data
    return MasterModule.MasterData
  }

  // FIlter By Dealer Name
  public dealerName: string = ''
  public dealerNameId: string = ''
  public byDealerName(text) {
    const find = this.dealerNameOptions.find(
      (e) => e.name === text.split('/')[0] || ''
    )
    const index = this.dealerNameOptions.indexOf(find)
    //  console.log(index)
    if (text.length >= 3 && index === -1) {
      MasterModule.paginationParam.search = text
      MasterModule.getDealerName()
    }
    const a = text.split('/')[1]
    if (this.dealerNameOptions.length > 0 && text.length >= 3) {
      this.dealerNameId =
        this.dealerNameOptions.find((e) => e.id === Number(a)).id || ''
    }
  }
  public dealerNameOptions: any = []
  public get dealerNameCode() {
    this.dealerNameOptions = MasterModule.DealerNameData.data
    return MasterModule.DealerNameData
  }

  // FIlter By Dealer Branch
  public dealerBranch: string = ''
  public dealerBranchId: string = ''
  public byDealerBranch(text) {
    const find = this.dealerBranchOptions.find((e) => e.name === text)
    const index = this.dealerBranchOptions.indexOf(find)
    if (text.length >= 3 && index === -1) {
      MasterModule.paginationParam.search = text
      MasterModule.getDealerBranch()
    }
    if (this.dealerBranchOptions.length > 0) {
      this.dealerBranchId = this.dealerBranchOptions.find(
        (e) => e.name === text
      ).id
    }
  }
  public dealerBranchOptions: any = []
  public get dealerBranchCode() {
    this.dealerBranchOptions = MasterModule.DealerBranchData.data
    return MasterModule.DealerBranchData
  }

  // filter by category
  public category: string = ''
  public categoryId: string = ''
  public byCategory(text) {
    // const find = this.categoryOptions.find((e) => e.name === text)
    // const index = this.categoryOptions.indexOf(find)
    if (text.length >= 3) {
      MasterCarStateDataModule.paginationParam.search = text
      MasterCarStateDataModule.getMasterCarData()
    }
    // if (this.categoryOptions.length >= 0) {
    //   this.categoryId = this.categoryOptions.find((e) => e.name === text).id
    // }
  }
  public categoryOptions: any = []
  public get categoryCode() {
    this.categoryOptions = MasterCarStateDataModule.masterCarData.data
    return MasterCarStateDataModule.masterCarData
  }
  public filterDate = []
}
